// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ZSOG","item":"PaymentsMobile_item__15Tdn","label":"PaymentsMobile_label__ZLlH1","amount":"PaymentsMobile_amount__1iSiz"};